import React from "react";
import style from "./index.module.scss";
import { Icon, Tooltip } from "antd";
import { ChainUploadFileProps } from "../../servers";
import { errorMessage, humanFileSize } from "service/service";

interface ListItemProps {
    file: ChainUploadFileProps;
}

export default function ListItem({ file }: ListItemProps) {
    return (
        <div
            className={style.root}
            style={{
                backgroundImage:
                    file.status === "uploading"
                        ? `linear-gradient(to right, #C0E4FF 0%, #C0E4FF ${file.percent}%, #fff ${file.percent}%, #fff 100%)`
                        : ""
            }}>
            <Tooltip title={file.file.name}>
                <div className={style.name}>{file.file.name || "NULL"}</div>
            </Tooltip>

            <div className={style.percent}>
                {humanFileSize(Number(file.file.size))}
            </div>

            <div className={style.status}>
                {file.status === "uploading" && (
                    <div className={style.uploading}>
                        <i className={style.icon1} /> 正在上传
                    </div>
                )}
                {file.status === "done" && (
                    <div className={style.success}>
                        <i className={style.icon2} /> 上传成功
                    </div>
                )}
                {file.status === "pending" && (
                    <div className={style.success}>
                        <Icon className={style.icon} type="pause-circle" />
                        正在排队
                    </div>
                )}
                {file.status === "error" && (
                    <div className={style.error}>
                        <i className={style.icon3} />{" "}
                        {errorMessage(file?.error?.message, "网络异常")}
                    </div>
                )}
                {file.status === "stop" && (
                    <div className={style.error}>
                        <i className={style.icon3} /> 不符合要求
                    </div>
                )}
            </div>
        </div>
    );
}
